import BitField from './BitField.js';

export default class AC_ID
{
	constructor()
	{
		this.flags = new BitField;
		this.commandIsInvOrPlay = false;
		this.state = [];
	}

	// saves internal state so that it can be modified, a calculation made, and then values can be restored after
	pushState()
	{
		this.state.push(this.flags);
		this.state.push(this.commandIsInvOrPlay);
	}

	// restores state from last push
	popState()
	{
		if(!this.state.length)
		{
			return;
		}
		this.commandIsInvOrPlay = this.state.pop();
		this.flags = this.state.pop();
	}

	// bit 5 0b00100000 is sound status
	get sound()
	{
		return this.flags.testBit(5);
	}
	set sound(value)
	{
		//console.warn(`sound = ${!!value}`);
		if(value)
		{
			this.flags.setBit(5);
		}
		else
		{
			this.flags.clearBit(5);
		}
	}

	// bits 4 and 3 0b00011000 are start condition
	// autoplay		= 00
	// pov 			= 01
	// clickToPlay	= 10
	// userLoaded	= 11
	get autoplay()
	{
		return !this.flags.testBit(4) && !this.flags.testBit(3);
	}
	set autoplay(value)
	{
		//console.warn(`autoplay = ${!!value}`);
		if(value)
		{
			this.flags.clearBit(4).clearBit(3);
		}
	}
	get pov()
	{
		return !this.flags.testBit(4) && this.flags.testBit(3);
	}
	set pov(value)
	{
		//console.warn(`playOnView = ${!!value}`);
		if(value)
		{
			this.flags.clearBit(4).setBit(3);
		}
	}
	get clickToPlay()
	{
		return this.flags.testBit(4) && !this.flags.testBit(3);
	}
	set clickToPlay(value)
	{
		//console.warn(`clickToPlay = ${!!value}`);
		if(value)
		{
			this.flags.setBit(4).clearBit(3);
		}
	}
	get userLoaded()
	{
		return this.flags.testBit(4) && this.flags.testBit(3);
	}
	set userLoaded(value)
	{
		//console.warn(`userLoaded = ${!!value}`);
		if(value)
		{
			this.flags.setBit(4).setBit(3);
		}
	}

	// bit 2 0b00000100 is first vs next play
	get nextPlay()
	{
		return this.flags.testBit(2);
	}
	set nextPlay(value)
	{
		//console.warn(`nextPlay = ${!!value}`);
		if(value)
		{
			this.flags.setBit(2);
		}
		else
		{
			this.flags.clearBit(2);
		}
	}

	// bit 1 0b00000010 is viewport status
	get outsideViewPort()
	{
		return this.flags.testBit(1);
	}
	set outsideViewPort(value)
	{
		// console.warn(`outsideViewPort = ${!!value}`);
		if(value)
		{
			this.flags.setBit(1);
		}
		else
		{
			this.flags.clearBit(1);
		}
	}

	// bit 0 0b00000001 is page visibility
	get pageHidden()
	{
		return this.flags.testBit(0);
	}
	set pageHidden(value)
	{
		// console.warn(`pageHidden = ${!!value}`);
		if(value)
		{
			this.flags.setBit(0);
		}
		else
		{
			this.flags.clearBit(0);
		}
	}

	// INV and PLAY ac_id's have special adjusted values. mark this adjustment for computed value generation
	setCmd(cmd)
	{
		switch(cmd.toLowerCase())
		{
			case 'inv':
			case 'play':
				this.commandIsInvOrPlay = true;
				break;
			default:
				this.commandIsInvOrPlay = false;
		}
	}
	
	getAdjustedBits()
	{
		// save the current value
		this.pushState();

		// mask off bits 6 and up 0b000xxxxx
		this.flags.mask(6);

		// if start type is click to play, mask off viewport and hidden if INV or PLAY
		if(this.clickToPlay && this.commandIsInvOrPlay)
		{
			this.outsideViewPort = false;
			this.pageHidden = false;
		}

		// if start type is user loaded, mask off firstPlay,viewport,hidden bits
		if(this.userLoaded)
		{
			this.nextPlay = false;
			this.outsideViewPort = false;
			this.pageHidden = false;
		}

		// if play type is pov
		if(this.pov)
		{
			// pov players always play while in view so...

			// If the CMD is INV or PLAY, or the player is nextPlay, clear the out of view bit.
			if(this.commandIsInvOrPlay || this.nextPlay)
			{
				this.outsideViewPort = false;
			}
		}

		// if the player is outside the viewport, ignore the hidden bit
		if(this.outsideViewPort)
		{
			this.pageHidden = false;
		}

		const result = new BitField(this.flags);
		this.popState();
		return result;
	}

	getViewabilityValue()
	{
		const t = this.getAdjustedBits();
		return t.testBit(0)?'H':(t.testBit(1)?'O':'I');
	}

	valueOf()
	{
		return 2000+this.getAdjustedBits();
	}

	toJSON()
	{
		return this.valueOf();
	}

	toString()
	{
		return ''+this.valueOf();
	}
}